// extracted by mini-css-extract-plugin
export var content = "textSection-module--content--8f310";
export var forceFloat = "textSection-module--forceFloat--37079";
export var image = "textSection-module--image--d46db";
export var left = "textSection-module--left--2724f";
export var right = "textSection-module--right--36445";
export var section = "textSection-module--section--9e7f8";
export var text = "textSection-module--text--5fc00";
export var title = "textSection-module--title--a54a3";